// src/components/homepage/BannerSwiper.jsx
import React, { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const PlayIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    className="w-10 h-10"
  >
    <path
      fillRule="evenodd"
      d="M2 10a8 8 0 1116 0 8 8 0 01-16 0zm6.39-2.908a.75.75 0 01.766.017l3.75 2.25a.75.75 0 010 1.282l-3.75 2.25A.75.75 0 018 12.25v-4.5a.75.75 0 01.39-.658z"
      clipRule="evenodd"
    />
  </svg>
);

const PauseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    className="w-10 h-10"
  >
    <path
      fillRule="evenodd"
      d="M2 10a8 8 0 1116 0 8 8 0 01-16 0zM9.25 6.75a.75.75 0 00-1.5 0v6.5a.75.75 0 001.5 0v-6.5zm3.5 0a.75.75 0 00-1.5 0v6.5a.75.75 0 001.5 0v-6.5z"
      clipRule="evenodd"
    />
  </svg>
);

const BannerSwiper = ({ banners }) => {
  const swiperRef = useRef(null);
  const [isAutoplaying, setIsAutoplaying] = useState(true);

  if (!banners || banners.length === 0) {
    return (
      <div className="bg-gray-200 h-64 md:h-96 flex items-center justify-center text-gray-500">
        No banners available.
      </div>
    );
  }

  const toggleAutoplay = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      const swiperInstance = swiperRef.current.swiper;
      if (swiperInstance.autoplay.running) {
        swiperInstance.autoplay.stop();
        setIsAutoplaying(false);
      } else {
        swiperInstance.autoplay.start();
        setIsAutoplaying(true);
      }
    }
  };

  return (
    <div className="relative">
      <Swiper
        ref={swiperRef}
        modules={[Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        pagination={{
          el: ".custom-swiper-pagination",
          clickable: true,
          bulletClass: "swiper-pagination-bullet custom-bullet",
          bulletActiveClass:
            "swiper-pagination-bullet-active custom-bullet-active",
        }}
        autoplay={
          isAutoplaying ? { delay: 5000, disableOnInteraction: false } : false
        }
        loop={true}
        className="w-full h-[200px] md:h-[400px] lg:h-[calc(100vh-80px)] max-h-[1000px] "
        onAutoplayTimeLeft={(s, time, progress) => {}}
      >
        {banners.map((banner, index) => (
          <SwiperSlide key={banner.id || index}>
            {banner.url ? (
              <a
                href={banner.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full h-full"
              >
                {banner.banner_image && banner.banner_image.url ? (
                  <img
                    src={`${banner.banner_image.url}`}
                    alt={
                      banner.banner_image.alternativeText ||
                      `Banner ${index + 1}`
                    }
                    className="w-full h-full object-contain"
                  />
                ) : (
                  <div className="w-full h-full bg-gray-300 flex items-center justify-center text-gray-500">
                    Image not available
                  </div>
                )}
              </a>
            ) : banner.banner_image && banner.banner_image.url ? (
              <img
                src={`${banner.banner_image.url}`}
                alt={
                  banner.banner_image.alternativeText || `Banner ${index + 1}`
                }
                className="w-full h-full object-contain"
              />
            ) : (
              <div className="w-full h-full bg-gray-300 flex items-center justify-center text-gray-500">
                Image not available
              </div>
            )}
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="absolute bottom-4 left-24 md:bottom-6 md:left-24 z-20 flex items-center space-x-3 p-2 rounded-full hidden md:flex">
        {" "}
        <div className="custom-swiper-pagination flex space-x-2"></div>
      </div>

      <style jsx global>{`
        .custom-swiper-pagination .custom-bullet {
          width: 50px;
          height: 10px;
          border-radius: 5px;
          border-color: rgba(255, 255, 255, 1);
          border-width: 1.5px;
          background-color: rgba(0, 51, 102, 0.25);
          opacity: 0.75;
          transition: background-color 0.3s ease, width 0.3s ease;
          margin: 0 2px !important;
        }
        .custom-swiper-pagination .custom-bullet-active {
          background-color: #003366;
          width: 100px;
        }
      `}</style>
    </div>
  );
};

export default BannerSwiper;
